import isEmpty from "lodash/isEmpty";
import UIButton from "@mui/material/Button";
import { useFormContext } from "react-hook-form";
import { queryClient } from "$utils/queryClient";
import { Button as LocalButton } from "$components";
import DeliverySummary from "../components/DeliverySummary";
import { useStyles } from "../styles/ProfileEDB.styles";
import DeliveryPicker from "../../form/steps/DeliveryPicker";
import { useProfileEDBContext } from "$containers/EDB/ProfileEDB/context/ProfileEDBContext";

export default function ShippingTab() {
  const classes = useStyles();
  const {
    getValues,
    formState: { errors, isValid },
  } = useFormContext();

  const {
    edb,
    integratedOrders,
    isModifyingDelivery,
    fetchEdb,
    updateEDB,
    setIsModifyingDelivery,
  } = useProfileEDBContext();

  const handleValidateDelivery = async () => {
    // Form can be valid but with an error
    // Also, errors can be an empty object and
    // gives false if you are trying to check it with !errors
    if (isValid && isEmpty(errors)) {
      const data = getValues();

      // Ensure dispositionDateIsExact is a boolean, not a string
      if (typeof data.dispositionDateIsExact === "string") {
        data.dispositionDateIsExact = data.dispositionDateIsExact === "true";
      }

      delete data.products;

      await updateEDB(
        {
          ...data,
          integratedOrders,
        },
        edb._id
      );

      await queryClient.removeQueries(["getEdbById", edb._id]); // THIS IS A PATCH BECAUSE FETCHEDB IS NOT AUTOMATIC
      await fetchEdb();
      setIsModifyingDelivery(false);
    }
  };

  if (!isModifyingDelivery) {
    return <DeliverySummary />;
  }

  return (
    <>
      <DeliveryPicker edbCompanyId={edb?.company._id} />
      <div className={classes.navigationStep}>
        <div>
          <UIButton
            variant="outlined"
            style={{ textTransform: "none" }}
            onClick={() => setIsModifyingDelivery(false)}
          >
            Précédent
          </UIButton>
        </div>
        <div>
          <LocalButton onClick={handleValidateDelivery}>Valider</LocalButton>
        </div>
      </div>
    </>
  );
}
